var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('EMigrateChallenge'),_c('EMigrateStructure'),_c('EMigrateAdvantage'),_c('EMigrateApplication')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }